import { render, staticRenderFns } from "./UsernameBtn.vue?vue&type=template&id=30db6caa&scoped=true"
import script from "./UsernameBtn.vue?vue&type=script&lang=js"
export * from "./UsernameBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30db6caa",
  null
  
)

export default component.exports